const isConnectorsOutput = (output) =>
  !!output
  && output.type === "output"
  && output.output_type === "calculation"
  && output.calculation?.length === 1
  && output.calculation[0].startsWith('{')
  && JSON.parse(output.calculation[0]).original === "connector";

const isSpreadsheetOutput = (output) =>
  !!output
  && output.type === "output"
  && output.output_type === "calculation"
  && output.calculation?.length === 1
  && output.calculation[0].startsWith('{')
  && JSON.parse(output.calculation[0]).original === "spreadsheet";

export const retrieveObjectPathValue = (
  obj,
  path,
  recursiveResponsesIndex = undefined,
  decimalPlaces = undefined,
) => {
  if (!obj)
    return undefined;

  const [field, ...rest] = path.split('.');
  if (rest.length === 0) {
    let value;
    if (recursiveResponsesIndex !== undefined) {
      if (0 <= recursiveResponsesIndex && recursiveResponsesIndex < obj.length)
        value = obj[recursiveResponsesIndex][field];
      else
        value = undefined;
    }
    else
      value = obj[field];
    if (!!value && typeof value === "number" && decimalPlaces !== undefined)
      value = Math.round(value * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
    if (typeof value === "boolean")
      value = JSON.stringify(value);
    return value;
  }

  if (recursiveResponsesIndex !== undefined)
    return retrieveObjectPathValue(obj[recursiveResponsesIndex][field], rest.join('.'), undefined, decimalPlaces);
  else
    return retrieveObjectPathValue(obj[field], rest.join('.'), undefined, decimalPlaces);
}

const evaluateJsonOutputValue = (output, context, recursiveResponsesIndex= undefined) => {
  const {
    output_input_id: targetOutputId,
    metadata_,
  } = output;

  const targetOutput = context?.configuration?.find((c) => c.id === targetOutputId);
  if (!targetOutput)
    throw Error(`output having ID ${targetOutputId} not found`);

  if (isConnectorsOutput(targetOutput)) {

    if (!metadata_?.path)
      throw Error(`path not specified inside metadata`);

    const calculationData = targetOutput.calculation?.length === 1 && targetOutput.calculation[0].startsWith('{')
      ? JSON.parse(targetOutput.calculation[0])
      : undefined;
    if (!calculationData)
      throw Error(`calculation data not found inside target output`);

    // Wood connector exception: if the path starts with "results", it means that is trying to access the array of
    // connectors alternatives. In this case, we need to find the selected connector and access the path inside it.
    const connectorType = calculationData.connector_type || "diaphragm";
    let object = context.connectionResults?.[connectorType];
    let path = metadata_.path;
    if (connectorType === "wood" && path.startsWith("results")) {
      const {responses} = context;
      const {blocks_mappings} = calculationData;
      const selected = responses[blocks_mappings._connector_choice_question]?.option?.option_value;
      if (!selected) {
        return undefined;
      } else {
        path = path.replace("results.", "");
        object = object?.results.find((r) => r.connector.name === selected);
        if (!object)
          return undefined;
      }
    }

    return retrieveObjectPathValue(
      object,
      path,
      undefined,
      // Client request: wood connectors float results must be rounded to 2 decimal places
      connectorType === "wood" ? 2 : undefined
    );
  }

  if (isSpreadsheetOutput(targetOutput)) {

    if (!metadata_?.path)
      throw Error(`path not specified inside metadata`);
    if (context.spreadsheetResults.hasOwnProperty(targetOutputId))
      return retrieveObjectPathValue(context.spreadsheetResults[targetOutputId], metadata_.path, recursiveResponsesIndex);
    else
      return undefined;
  }

  throw Error(`target output is neither a connector output nor a spreadsheet output`)
}

export default evaluateJsonOutputValue;